import { Injectable, inject } from '@angular/core';
import { HcToasterService, HcToastOptions, HcToastRef, ToastContentType } from '@healthcatalyst/cashmere';

@Injectable({
    providedIn: 'root'
})
export class ToastNotificationService {
    private defaultToastLocation = 'bottom-right';
    private toasterService = inject(HcToasterService);

    constructor() {}

    public showSuccess(message: string, header = '', overrideOptions?: HcToastOptions): HcToastRef {
        const defaultOptions: HcToastOptions = {
            header: header,
            body: message,
            position: this.defaultToastLocation,
            type: 'success',
            timeout: 5000,
            clickDismiss: true,
            width: 320
        };

        const options = Object.assign(defaultOptions, overrideOptions);

        return this.toasterService.addToast(options);
    }

    public showWarning(message: string, header = '', overrideOptions?: HcToastOptions): HcToastRef {
        const defaultOptions: HcToastOptions = {
            header: header,
            body: message,
            position: this.defaultToastLocation,
            type: 'warning',
            timeout: 0,
            clickDismiss: true,
            width: 320
        };

        const options = Object.assign(defaultOptions, overrideOptions);

        return this.toasterService.addToast(options);
    }

    public showError(message: string, header = '', overrideOptions?: HcToastOptions): HcToastRef {
        const defaultOptions: HcToastOptions = {
            header: header,
            body: message,
            position: this.defaultToastLocation,
            type: 'alert',
            timeout: 0,
            clickDismiss: true,
            width: 320
        };

        const options = Object.assign(defaultOptions, overrideOptions);

        return this.toasterService.addToast(options);
    }

    public showProgress(message: string, header = '', overrideOptions?: HcToastOptions): HcToastRef {
        const defaultOptions: HcToastOptions = {
            header: header,
            body: message,
            position: this.defaultToastLocation,
            type: 'info',
            timeout: 0,
            clickDismiss: true,
            width: 320,
            hasProgressBar: true
        };

        const options = Object.assign(defaultOptions, overrideOptions);

        return this.toasterService.addToast(options);
    }

    public showCustomToast<T>(customToast: ToastContentType<T>, overrideOptions?: HcToastOptions) {
        const defaultOptions: HcToastOptions = {
            position: this.defaultToastLocation,
            type: 'custom',
            timeout: 0,
            width: 375
        };

        const options = Object.assign(defaultOptions, overrideOptions);
        return this.toasterService.addToast(options, customToast);
    }
}
